module.exports = __webpack_public_path__ + "static/media/浮标.c72a3e4e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/浮标.gif
// module id = 1250
// module chunks = 0